import { useLocation } from 'react-router-dom'
import { useMemo } from 'react'
import { AddNewIntegrationModal } from 'app/components/integrations/AddNewIntegrationModal'
import { AddNewWorkspaceIntegrationModal } from 'app/components/integrations/AddNewWorkspaceIntegrationModal'
import { showModal } from 'app/lib/modal'
import type { TabType } from 'app/components/Tabs'

export type UseIntegrationsLayoutReturn = {
  tabs: TabType[]
  primaryButtonSlot: React.ReactElement
}

export function useIntegrationsLayout(): UseIntegrationsLayoutReturn {
  const location = useLocation()
  const openTab = useMemo(() => (location.pathname.match(`locations`) ? `locations` : `workspace`), [location.pathname])

  function onIntegrationAdded() {
    window.dispatchEvent(new CustomEvent(`integrations:refetch`))
  }

  const tabs: TabType[] = [
    { name: `Locations`, href: `/settings/integrations/locations` },
    { name: `Workspace`, href: `/settings/integrations/workspace` },
  ]

  const primaryButtonSlot =
    openTab === `locations` ? (
      <button
        className="btn btn-primary btn-md"
        onClick={() =>
          showModal(<AddNewIntegrationModal onIntegrationAdded={onIntegrationAdded} />, {
            title: `Add New Integration`,
            isFullScreen: false,
            overflowHidden: false,
            removePadding: true,
            useRadix: true,
          })
        }
      >
        + New Integration
      </button>
    ) : (
      <button
        className="btn btn-primary btn-md"
        onClick={() =>
          showModal(<AddNewWorkspaceIntegrationModal onIntegrationChanged={onIntegrationAdded} />, {
            title: `Add New Workspace Integration`,
            isFullScreen: false,
            overflowHidden: false,
            removePadding: true,
            useRadix: true,
          })
        }
      >
        + New Workspace Integration
      </button>
    )

  return { tabs, primaryButtonSlot }
}
